/**
 * File objects can't go through Redux (non-serialisable), but the optimistic bubble
 * has to appear before the upload starts. Files are parked here by client_msg_id and
 * read back by the send saga - including on retry, which is why they outlive the send.
 *
 * Blob preview URLs are tracked alongside them. A bubble renders its preview until the
 * ack swaps in a presigned URL, so neither the file of a failed send nor a preview can
 * be released while the thread is still open; both are dropped when it closes.
 */
const parked = new Map();
const previewUrls = new Set();

export const parkAttachments = (clientMsgId, files, previews) => {
  if (files?.length) parked.set(clientMsgId, { files, assetIds: null });
  previews?.forEach((url) => previewUrls.add(url));
};

export const takeAttachments = (clientMsgId) => parked.get(clientMsgId) || null;

// Uploaded ids are cached so a retry re-posts the same assets instead of
// uploading duplicates that the send dedupe would then orphan.
export const rememberAssetIds = (clientMsgId, assetIds) => {
  const entry = parked.get(clientMsgId);
  if (entry) entry.assetIds = assetIds;
};

export const releaseAttachments = (clientMsgId) => parked.delete(clientMsgId);

/**
 * Teardown. A send that failed keeps its files parked so it can be retried, but once
 * the thread or console closes that retry is gone - without this they accumulate for
 * the lifetime of the page, as do the blob URLs behind every preview ever rendered.
 */
export const releaseAllAttachments = () => {
  parked.clear();
  previewUrls.forEach((url) => URL.revokeObjectURL(url));
  previewUrls.clear();
};
